export * from "json-schema-typed/draft-2019-09";
//#region src/Validation/Validator.ts
var e = class {
	constructor() {
		this.initialized = !1;
	}
	async initialize() {
		this.initialized ||= (await this.initializeInternal(), !0);
	}
	validateJsonSchema(e) {
		if (!this.initialized) throw Error("Validator not initialized");
		return this.validateJsonSchemaInternal(e);
	}
	validateUiSchema(e) {
		if (!this.initialized) throw Error("Validator not initialized");
		return this.validateUiSchemaInternal(e);
	}
}, t = class extends e {
	async initializeInternal() {}
	validateJsonSchemaInternal(e) {
		return !0;
	}
	validateUiSchemaInternal(e) {
		return !0;
	}
	getJsonSchemaValidationErrors() {
		return [];
	}
	getUiSchemaValidationErrors() {
		return [];
	}
};
//#endregion
export { t as EmptyValidator, e as Validator };

//# sourceMappingURL=vue-json-form-schemas.js.map